const RESIZE_MODES = {
    contain: 'contain',
    cover: 'cover',
    stretch: 'stretch',
    center: 'center',
};

export default RESIZE_MODES;
